import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Constants } from '../util/constants';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
    public storeUserLanguage(language: string, userId: number) {
        localStorage.setItem(`${Constants.LOCAL_STORAGE_USER_LANGUAGE}-${environment.type}-${userId}`, language);
    }

    public retrieveUserLanguage(userId: number): string {
        return localStorage.getItem(`${Constants.LOCAL_STORAGE_USER_LANGUAGE}-${environment.type}-${userId}`);
    }

    public storeCurrentUser(userInfo: string, userId: number) {
        localStorage.setItem(`${Constants.LOCAL_STORAGE_CURRENT_USER_ID}-${environment.type}`, userId.toString());
        localStorage.setItem(`${Constants.LOCAL_STORAGE_CURRENT_USER}-${environment.type}-${userId}`, userInfo);
    }

    public retrieveCurrentUser(): string {
        const currentUserId = localStorage.getItem(`${Constants.LOCAL_STORAGE_CURRENT_USER_ID}-${environment.type}`);

        return localStorage.getItem(`${Constants.LOCAL_STORAGE_CURRENT_USER}-${environment.type}-${currentUserId}`);
    }

    public removeCurrentUser() {
        const currentUserId = localStorage.getItem(`${Constants.LOCAL_STORAGE_CURRENT_USER_ID}-${environment.type}`);

        if (currentUserId) {
            localStorage.removeItem(`${Constants.LOCAL_STORAGE_CURRENT_USER_ID}-${environment.type}`);
            localStorage.removeItem(`${Constants.LOCAL_STORAGE_CURRENT_USER}-${environment.type}-${currentUserId}`);
        }
    }
}
